<template>
  <div class="fixed" v-min-height>
    <c-view>
      <c-page>
        <c-content>
          <div class="active-payment">
            <div class="header bg-img">
              <div class="header-desc">
                <img class="alpha-logo" src="../../assets/images/logo/logo.png" alt="">
                <div class="text-desc">请绑定已开通扫码收款的店铺</div>
              </div>
            </div>
            <div class="content">
              <div class="register-form">
                <div class="s-form-group bind-telephone">
                  <i class="s-icon s-icon-telephone prepend-icon"></i>
                  <input type="tel" class="prepend-icon" maxlength="11"
                         @input="validPhone=false" placeholder="请输入手机号码" @blur="validatePhone()" v-model="formItem.telephoneNum">
                  <i class="s-icon s-icon-check-circle-italic" v-show="validPhone"></i>
                </div>
                <div class="s-form-group valid-code">
                  <i class="s-icon s-icon-password prepend-icon"></i>
                  <input type="tel" class="prepend-icon" @input="validPass=false" placeholder="请输入验证码"
                         maxlength="6"
                         v-model="formItem.verifyCodeNum">
                  <i class="s-icon s-icon-check-circle-italic" v-show="validPass"></i>
                  <button class="input-button" :class="[!validPhone ? 'disabled' : '']" :disabled="!validPhone" @click="getCode()">
                    <span class="text-color gray" v-if="formItem.codeWorking"> {{formItem.timeSecond}}</span>
                    <span v-else>发送验证码</span>
                  </button>
                </div>
              </div>
              <!-- shop name -->
              <div class="shop-name" v-if="storeName">
              <span>
                {{storeName}}
              </span>
              </div>
              <div class="s-btn s-btn--orange" @click="nextStep()">立即激活</div>
              <!-- 使用说明 -->
              <div class="text-center use-info">
                <span @click="toggleDialog()">使用说明</span>
              </div>
            </div>
            <div class="footer-container">
              <info-footer></info-footer>
            </div>
          </div>
        </c-content>
        <c-dialog v-if="showDialog">
          <div slot="bd-content">
            <div class="scroll-content">
              <img class="info-img" src="../../assets/images/active-payment/info.png" alt="使用说明">
            </div>
            <button class="text-color orange closeDialog" @click="toggleDialog">我知道了</button>
          </div>
        </c-dialog>
        <div class="s-dialog-mask" v-if="ifShowDialog">
          <div class="s-mask"></div>
          <div class="s-dialog-box">
            <div class="s-dialog-content">
              <div class="close-box">
                <img src="http://static.i200.cn/benjamin/mainWeb/FvmMxgTagfifVZRDXnMuy_VyUYZb.png" @click="closeDialog">
              </div>
              <div class="img-box">
                <img class="info-img" :src="dialogDetail.img"/>
              </div>
              <div class="text-content">
                <div>
                  <p class="content-title">{{dialogDetail.title}}</p>
                  <p class="content-detail">下载生意专家手机APP进行注册可实时</p>
                  <p class="content-detail">接收收款通知</p>
                </div>
                <button class="bind-account" @click="clearPhone">绑定其他账号</button>
                <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.ShengYiZhuanJia.five">
                  <button class="download-app">下载APP</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </c-page>
      <router-view></router-view>
    </c-view>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import ActivePayment from '../../model/active-payment/index'
  import InfoFooter from '../info-footer'
  import CDialog from '../components/c-dialog'

  export default {
    data () {
      const formModel = new ActivePayment()
      return {
        formModel,
        formItem: formModel.formItem,
        validName: false,
        validPhone: false,
        validPass: false,
        canEdit: true,
        showDialog: false,
        ifShowDialog: false,
        dialogDetail: {
          img: '',
          title: ''
        }
      }
    },
    components: {InfoFooter, CDialog},
    created () {
    },
    mounted () {
      this.formItem.paymentCode = this.getQueryVariable('hashcode') // 获取hashcode
    },
    beforeDestroy () {
    },
    methods: {
      closeDialog () {
        this.ifShowDialog = false
      },
      clearPhone () {
        this.closeDialog()
        this.formItem.telephoneNum = ''
      },
      toggleDialog () {
        this.showDialog = !this.showDialog
      },
      getQueryVariable (variable) {
        let query = window.location.search.substring(1)
        let vars = query.split('&')
        for (let i = 0; i < vars.length; i++) {
          let pair = vars[i].split('=')
          if (pair[0] === variable) {
            return pair[1]
          }
        }
        return false
      },
      testPhone (value) {
        return /^1\d{10}$/.test(value)
      },
      testName (value) {
        return value && value.length < 9
      },
      testNull (value) {
        return value && value.length !== 0
      },
      async validatePhone () {
        // 执行验证手机号码是否注册

        if (!this.testNull(this.formItem.telephoneNum)) {
          this.$wejs.alert('手机号不能为空')
          this.validPhone = false
          return false
        }
        if (!this.testPhone(this.formItem.telephoneNum)) {
          this.$wejs.alert('手机号码错误，请输入正确的手机号')
          this.validPhone = false
          return false
        }
        // 验证手机号码是否注册
        this.validPhone = await this.checkRegister()
        this.validPhone = await this.checkStatus()
        return this.validPhone
      },
      async validatePass () {
        if (!this.formItem.verifyCodeNum) {
          this.$wejs.alert('请输入验证码')
          this.validPass = false
          return
        }
        if (this.formItem.verifyCodeNum.length !== 6) {
          this.$wejs.alert('请输入正确的6位数验证码”')
          this.validPass = false
          return
        }
        this.validPass = await this.checkVerify()
        return this.validPass
      },
      validStoreName () {
        if (!this.formItem.storeName) {
          this.$wejs.alert('请输入店铺名称')
          this.validName = false
          return
        }
        this.validName = true
        return true
      },
      getStoreName () {
        this.formModel.getOrginStoreName().then(res => {
          console.log('getOrginStoreName', res)
          this.formItem.storeName = res
          this.formItem.originName = res
          if (res && res !== '') {
            this.canEdit = false
          } else {
            this.formItem.newName = this.formItem.storeName
          }
        })
      },
      checkVerify () {
        return new Promise(resolve => {
          this.formModel.checkVertifyCode().then(res => {
            let data = res
            if (data) {
              this.getStoreName() // 显示店铺名称
              resolve(true)
            } else {
              this.$wejs.toast('验证码错误', {
                className: 's-toast-error'
              })
              resolve(false)
            }
          })
        })
      },
      checkRegister () {
        return new Promise(resolve => {
          this.formModel.verifyRegister().then(res => {
            if (!res) {
              this.dialogDetail = {
                img: require('../../assets/images/active-payment/unregistered.png'),
                title: '该手机号未注册生意专家'
              }
              this.ifShowDialog = true
              // this.$wejs.alert('该手机号未注册生意专家')
              resolve(false)
            } else {
              resolve(true)
            }
          })
        })
      },
      checkStatus () {
        return new Promise(resolve => {
          this.formModel.getStatus().then(res => {
            if (!res) {
              this.dialogDetail = {
                img: require('../../assets/images/active-payment/noOpen.png'),
                title: '该手机号未开通扫码收款功能'
              }
              this.ifShowDialog = true
              // this.$wejs.alert('您未开通扫码收款功能，请在生意专家内进行开通')
              resolve(false)
            } else {
              resolve(true)
            }
          })
        })
      },
      async getVerifyCodeFunc () {
        this.formModel.getVerifyCode().then((res) => {
          if (res !== 0) {
            return this.$wejs.alert('发生异常，请致电生意专家客服：</br>' + '<a class="text-color primary" href="tel:400-168-3399"> 400-168-3399 </a>', {
              className: 's-dialog-alert'
            })
          } else {
            this.$wejs.toast('验证码已发送')
            this.formItem.codeWorking = true
            this.validPhone = true
            this.formModel.fireTimer()
          }
        }).catch((e) => {
          this.$wejs.alert('抱歉发送出错', () => {
          })
        })
      },
      async nextStep () {
        if (!await this.validatePhone() || !this.validatePass() || !this.validStoreName()) return
        this.formModel.activePayment().then(() => {
          this.$router.push('/active-payment/success')
        }).catch(e => {
          this.$wejs.alert('发生异常，请致电生意专家客服：</br>' + '<a class="text-color primary" href="tel:400-168-3399"> 400-168-3399 </a>', {
            className: 's-dialog-alert'
          })
        })
      },
      async getCode () {
        if (!await this.validatePhone()) return
        this.getVerifyCodeFunc()
      },
      emptyChange () {
        this.formItem.verifyCodeNum = ''
        this.formItem.storeName = ''
      }
    },
    computed: {
      storeName () {
        return this.formItem.storeName ? `${this.formItem.storeName}` : ''
      }
    },
    watch: {
      'formItem.storeName': function (val) {
        if (!val || val === '') {
          this.validName = false
        }
      },
      'formItem.telephoneNum': function (val) {
        if (val !== 11) {
          this.emptyChange()
        }
      },
      'formItem.verifyCodeNum': function (val) {
        if (!val || val === '') {
          this.validPass = false
        }
        if (val.length === 6) {
          this.checkVerify().then(res => {
            if (res) {
              this.validPass = true
            }
          }).catch(e => {
          })
        } else {
          this.validPass = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?bbafea88